import { Analytics, AttachMoney, Bolt, Build, RocketLaunch, Sync } from "@mui/icons-material";
import { Grid, SxProps, Typography } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionSubtitle } from "src/modules/SectionSubtitle/SectionSubtitle";
import { IconCircle } from "src/modules/IconCircle/IconCircle";
import { Card } from "../../modules";
import { Theme } from "@emotion/react";

export const Advantages = () => {
  return (
    <SectionContainer sx={{ background: "rgba(34, 161, 185, 0.1)" }}>
      <SectionTitle sx={{ color: "#22A1B9" }}>テクノスタンダードの優位性</SectionTitle>
      <SectionSubtitle>大手ITベンダーと比較して優位な価格設定とサービス品質を提供</SectionSubtitle>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card variant="light" sx={advantageCardSx}>
            <Card.Title>
              <IconCircle size="tiny" variant="success" sx={{ display: "inline-flex" }}>
                <AttachMoney />
              </IconCircle>
              優位な価格設定
            </Card.Title>
            <Typography variant="body2">
              大手ITベンダーと比較して、基本料金を抑えた価格設定でサービスを提供しています。プレミアムプランでは、高品質なサービスをリーズナブルな価格でご提供いたします。
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card variant="light" sx={advantageCardSx}>
            <Card.Title>
              <IconCircle size="tiny" variant="success" sx={{ display: "inline-flex" }}>
                <Bolt />
              </IconCircle>
              メニュー外対応の実現
            </Card.Title>
            <Typography variant="body2">
              予期せぬトラブルや複雑な問題にも柔軟に対応できるよう努めています。標準メニューの枠を超えた対応により、お客様の課題解決をサポートいたします。
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card variant="light" sx={advantageCardSx}>
            <Card.Title>
              <IconCircle size="tiny" variant="success" sx={{ display: "inline-flex" }}>
                <Sync />
              </IconCircle>
              ハイブリッド対応体制
            </Card.Title>
            <Typography variant="body2">
              副業エンジニアと生成AIの組み合わせにより、効率的なサービス提供を目指しています。AIと人間のエンジニアが連携して対応いたします。
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card variant="light" sx={advantageCardSx}>
            <Card.Title>
              <IconCircle size="tiny" variant="success" sx={{ display: "inline-flex" }}>
                <Analytics />
              </IconCircle>
              透明性の高い管理
            </Card.Title>
            <Typography variant="body2">
              RedmineとSlackの連携により、情報の一元管理と透明性の高いコミュニケーションを心がけています。お客様とのやりとりを可視化いたします。
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card variant="light" sx={advantageCardSx}>
            <Card.Title>
              <IconCircle size="tiny" variant="success" sx={{ display: "inline-flex" }}>
                <RocketLaunch />
              </IconCircle>
              プロアクティブな改善提案
            </Card.Title>
            <Typography variant="body2">
              単なる運用代行ではなく、システム最適化やアーキテクチャ改善など、お客様のビジネス成長に貢献する提案を行います。
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card variant="light" sx={advantageCardSx}>
            <Card.Title>
              <IconCircle size="tiny" variant="success" sx={{ display: "inline-flex" }}>
                <Build />
              </IconCircle>
              柔軟なスケールアップ
            </Card.Title>
            <Typography variant="body2">
              成長フェーズにあるビジネスには、段階的にプランをアップグレードしていくことも可能です。お客様の成長に合わせたサービス提供を心がけています。
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

const advantageCardSx: SxProps<Theme> = {
  height: "100%",
};
